export const obrasTable = () => [
  { label: "Nombre", key: "nombre" },
  { label: "Notas", key: "notas" },
];
